export default __webpack_public_path__ + "static/media/whitev3.a18e403e.svg";